import React from "react";

const Button = ({ disabled, type = "button", onClick, text = "", bgColor = "black", width = "w-44 md:w-64", ...res }) => {
	let colorClass = "";

	if (bgColor === "black") {
		colorClass = "bg-black text-white";
	} else if (bgColor === "white") {
		colorClass = "bg-white text-black";
	} else if (bgColor === "red") {
		colorClass = "bg-rs-rojo text-white";
	} else if (bgColor === "blue") {
		colorClass = "bg-rs-azul text-white";
	} else if (bgColor === "green") {
		colorClass = "bg-green-600 text-white";
	} else if (bgColor === "orange") {
		colorClass = "bg-orange-600 text-white";
	}

	const baseClass = `${width} h-12 rounded-full py-2 flex flex-row items-center justify-center transition duration-300 ease-in-out`;

	const disabledClass = "bg-gray-500 text-white cursor-not-allowed";

	const buttonClass = `${baseClass} ${colorClass} ${
		disabled ? disabledClass : "cursor-pointer hover:scale-105"
	}`;

	return (
		<button
			disabled={disabled}
			type={type}
			onClick={onClick}
			className={buttonClass}
			{...res}
		>
			{text}
		</button>
	);
};

export default Button;
